{
  "en": {
    "languages": {
      "ar": "Arabic",
      "cs": "Czech",
      "da": "Danish",
      "de": "German",
      "el": "Greek",
      "en": "English",
      "es": "Spanish",
      "fi": "Finnish",
      "fr": "French",
      "he": "Hebrew",
      "hu": "Hungarian",
      "it": "Italian",
      "ja": "Japanese",
      "ko": "Korean",
      "nl": "Dutch",
      "no": "Norwegian",
      "pl": "Polish",
      "pt": "Portuguese",
      "ro": "Romanian",
      "ru": "Russian",
      "sk": "Slovak",
      "sv": "Swedish",
      "th": "Thai",
      "uk": "Ukrainian",
      "vi": "Vietnamese",
      "zh": "Chinese"
    }
  }
}
